import React, { useEffect } from 'react';
import { datadogRum } from '@sunbit-dev/common/services/datadog';
import { logsService } from '~/services/LogsService';
import { useSelector } from 'react-redux';
import { getStore as getPurchaseStore } from '~/store/reducers/purchase/purchase';
import { getStore as getErrorsStore } from '~/store/reducers/errors/errors';
import { getStore as getCustomerStore } from '~/store/reducers/customer/customer';

export const LogsTracking = () => {
  const purchaseState = useSelector(getPurchaseStore);
  const errorsState = useSelector(getErrorsStore);
  const customerState = useSelector(getCustomerStore);

  useEffect(() => {
    logsService.setInfo({ purchaseState, errorsState, customerState });
    // uses service getter for data structure + masking
    datadogRum.addRumGlobalContext('app', logsService.info);
  }, [purchaseState, errorsState, customerState]);

  return null;
};
